<svg viewBox="0 0 624 339" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M311.994 245.579C244.184 245.579 189.214 300.548 189.214 368.358H434.783C434.783 300.548 379.814 245.579 312.004 245.579H311.994Z"
    fill="#FF6B17"
  />
  <path
    d="M424.543 221.005C420.717 212.239 415.89 204.009 410.218 196.449C403.236 187.147 394.965 178.875 385.662 171.893C365.139 156.475 339.634 147.337 311.984 147.337C284.334 147.337 258.829 156.475 238.306 171.893C229.003 178.875 220.732 187.147 213.75 196.449C208.078 204.009 203.251 212.239 199.425 221.005C196.022 228.802 193.392 237.022 191.659 245.561H432.309C430.576 237.022 427.946 228.802 424.543 221.005Z"
    fill="#FF6B17"
  />
  <path
    d="M410.23 122.782C403.248 113.479 394.977 105.208 385.674 98.2257C365.151 82.8073 339.646 73.6698 311.996 73.6698C284.347 73.6698 258.842 82.8073 238.318 98.2257C229.026 105.208 220.745 113.479 213.763 122.782C208.09 130.341 203.264 138.571 199.438 147.337H424.545C420.719 138.571 415.892 130.341 410.22 122.782H410.23Z"
    fill="#FF6B17"
  />
  <path
    d="M385.672 49.1035C365.148 33.6852 339.643 24.5476 311.994 24.5476C284.344 24.5476 258.839 33.6852 238.316 49.1035C229.023 56.0856 220.742 64.3671 213.76 73.6594H410.217C403.235 64.3568 394.964 56.0856 385.661 49.1035H385.672Z"
    fill="#FF6B17"
  />
  <path
    d="M385.68 24.5558C365.156 9.13743 339.641 -0.00012207 312.002 -0.00012207C284.362 -0.00012207 258.847 9.13743 238.324 24.5558H385.68Z"
    fill="#FF6B17"
  />
  <path
    d="M189.199 24.5476C161.549 24.5476 136.044 33.6852 115.521 49.1035C106.229 56.0856 97.9472 64.3671 90.9651 73.6594H189.199V24.5476Z"
    fill="#FF6B17"
  />
  <path
    d="M66.4534 368.358H189.233V245.579C121.423 245.579 66.4534 300.548 66.4534 368.358Z"
    fill="#FF6B17"
  />
  <path
    d="M189.202 73.6698C161.552 73.6698 136.048 82.8073 115.524 98.2257C106.222 105.208 97.9505 113.479 90.9684 122.782C85.2961 130.341 80.4695 138.571 76.6433 147.337H189.202V73.6698Z"
    fill="#FF6B17"
  />
  <path
    d="M189.223 147.337C161.573 147.337 136.069 156.475 115.545 171.893C106.243 178.875 97.9715 187.147 90.9894 196.449C85.3172 204.009 80.4905 212.239 76.6643 221.005C73.2609 228.802 70.6311 237.022 68.8984 245.561H189.223V147.337Z"
    fill="#FF6B17"
  />
  <path
    d="M66.4419 90.1192C62.1825 92.5841 58.0779 95.2965 54.1588 98.2357C44.8563 105.218 36.585 113.489 29.603 122.792C23.9307 130.351 19.1041 138.581 15.2778 147.347H66.4419V90.1089V90.1192Z"
    fill="#FF6B17"
  />
  <path
    d="M66.4388 163.762C62.1794 166.227 58.0747 168.939 54.1557 171.878C44.8531 178.86 36.5819 187.132 29.5998 196.434C23.9275 203.994 19.1009 212.224 15.2747 220.99C11.8713 228.787 9.24142 237.006 7.50879 245.546H66.4388V163.751V163.762Z"
    fill="#FF6B17"
  />
  <path
    d="M5.03442 368.344H66.4293V261.994C29.7347 283.229 5.03442 322.904 5.03442 368.344Z"
    fill="#FF6B17"
  />
  <path
    d="M5.03264 188.932C2.88749 191.356 0.835146 193.862 -1.11406 196.45C-6.78636 204.01 -11.613 212.24 -15.4392 221.006C-18.8426 228.803 -21.4724 237.023 -23.2051 245.562H5.03264V188.932Z"
    fill="#FF6B17"
  />
  <path
    d="M-25.6602 368.355H5.03212V287.148C-14.068 308.796 -25.6602 337.219 -25.6602 368.355Z"
    fill="#FF6B17"
  />
  <path
    d="M434.769 24.5476C462.419 24.5476 487.923 33.6852 508.447 49.1035C517.739 56.0856 526.021 64.3671 533.003 73.6594H434.769V24.5476Z"
    fill="#FF6B17"
  />
  <path
    d="M557.548 368.358H434.769V245.579C502.578 245.579 557.548 300.548 557.548 368.358Z"
    fill="#FF6B17"
  />
  <path
    d="M434.769 73.6698C462.419 73.6698 487.923 82.8073 508.447 98.2257C517.749 105.208 526.021 113.479 533.003 122.782C538.675 130.341 543.502 138.571 547.328 147.337H434.769V73.6698Z"
    fill="#FF6B17"
  />
  <path
    d="M434.769 147.337C462.419 147.337 487.923 156.475 508.447 171.893C517.749 178.875 526.021 187.147 533.003 196.449C538.675 204.009 543.502 212.239 547.328 221.005C550.731 228.802 553.361 237.022 555.094 245.561H434.769V147.337Z"
    fill="#FF6B17"
  />
  <path
    d="M557.554 90.1193C561.813 92.5842 565.918 95.2966 569.837 98.2359C579.139 105.218 587.411 113.489 594.393 122.792C600.065 130.351 604.892 138.581 608.718 147.348H557.554V90.109V90.1193Z"
    fill="#FF6B17"
  />
  <path
    d="M557.554 163.762C561.813 166.227 565.918 168.939 569.837 171.878C579.139 178.86 587.411 187.132 594.393 196.434C600.065 203.994 604.892 212.224 608.718 220.99C612.121 228.787 614.751 237.006 616.484 245.546H557.554V163.751V163.762Z"
    fill="#FF6B17"
  />
  <path
    d="M618.949 368.344H557.554V261.994C594.248 283.229 618.949 322.904 618.949 368.344Z"
    fill="#FF6B17"
  />
  <path
    d="M618.958 188.932C621.103 191.356 623.156 193.862 625.105 196.45C630.777 204.01 635.604 212.24 639.43 221.006C642.833 228.803 645.463 237.023 647.196 245.562H618.958V188.932Z"
    fill="#FF6B17"
  />
  <path
    d="M649.651 368.355H618.958V287.148C638.058 308.796 649.651 337.219 649.651 368.355Z"
    fill="#FF6B17"
  />
</svg>
